export default "__VITE_ASSET__6a3d9257__"